import { motion } from 'motion/react'
import { ReactNode } from 'react'

interface AnimatedContainerProps {
  children: ReactNode
  className?: string
  staggerDelay?: number
}

// Animation variants for container with staggered children
const containerVariants = {
  hidden: { opacity: 0 },
  visible: (staggerDelay: number) => ({
    opacity: 1,
    transition: {
      staggerChildren: staggerDelay
    }
  })
}

export function AnimatedContainer({
  children,
  className,
  staggerDelay = 0.1
}: AnimatedContainerProps) {
  return (
    <motion.div
      className={className}
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      custom={staggerDelay}
    >
      {children}
    </motion.div>
  )
}
